import styled from 'styled-components'

export const WithApprovalPoolTooltipContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.medium};
  padding: ${(props) => props.theme.space.large};
`
